import { render, staticRenderFns } from "./ProgramsManageLink.vue?vue&type=template&id=1df2219e&"
import script from "./ProgramsManageLink.vue?vue&type=script&lang=js&"
export * from "./ProgramsManageLink.vue?vue&type=script&lang=js&"
import style0 from "@/assets/styles/themes/default/tracks.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports